import React from "react";
import classNames from "classnames";
import "./index.scss";

export default ({ text, typeStatus }) => (
  <div className={classNames("statusControl")}>
    {!!text && <div className={classNames(typeStatus)}>{text}</div>}
  </div>
);
